import React from 'react';
import cx from 'classnames';
import {
    PriorityIcon,
    Icon,
    Popover,
    PopoverPlacement
} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

type Props = {
    image: string;
};

export const ImageWithPopover = (props: Props) => {
    return (
        <Popover
            {...createDataTestId('popover-with-img-container', true)}
            hoverable
            zIndex={12500}
            placement={PopoverPlacement.top}
            popoverComponentClass={styles.popover}
            componentClasses={cx(styles.imagePlaceholder, styles.blockAlignment)}
            content={
                <img
                    width={60}
                    height={60}
                    src={props.image}
                    alt=""
                    {...createDataTestId('popover-with-img-text', false)}
                />
            }
        >
            <Icon icon={PriorityIcon.File} componentClasses={styles.icon} />
        </Popover>
    );
};
